module.exports = __webpack_public_path__ + "static/media/naturgy.8fc08819.webp";